import createOpenApiClient from "openapi-fetch";
import { createCenterOpenApiFetch, getCenterOpenApiClientOrigin } from "@/lib/center-api";
import { SSO_CENTER_MANAGEMENT_API_BASE_URL } from "@/lib/env";
import type { paths } from "@airange/generated-contracts/sso-center";

export function createSsoCenterOpenApiClient(baseUrl = SSO_CENTER_MANAGEMENT_API_BASE_URL) {
  return createOpenApiClient<paths>({
    baseUrl: getCenterOpenApiClientOrigin(baseUrl),
    fetch: createCenterOpenApiFetch(baseUrl),
  });
}

export const ssoCenterOpenApiClient = createSsoCenterOpenApiClient();
